import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { handlePostRequest } from '../../utils/api-handler.util'
import { showToaster } from '../../utils/show-toaster.util'
import { useAuth } from '../../contexts/AuthContext'
import Modal from '../../components/common/Modal'
import { useNavigate } from 'react-router-dom'
import { QueryKeys } from '../../utils/queryKeyGenerator'

export default function SendModal({
  isOpen,
  onClose,
  targetId,
  targetUserType,
  contextType,
  contextId,
  description = '',
}) {
  const { userType } = useAuth()
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  const sendMutation = useMutation({
    mutationFn: async () => {
      const endpoint = `/${userType}s/messages/send`
      const response = await handlePostRequest(endpoint, {
        message,
        targetId,
        contextType,
        contextId,
      })
      return response.data
    },
    onSuccess: (responseData) => {
      showToaster('success', 'Message sent successfully')
      setMessage('')
      onClose()
      const conversationId = responseData.conversationId
      if (conversationId) {
        QueryKeys.listConversationMessages.invalidate(conversationId.toString(), userType)
        navigate(`/messages/${conversationId}`)
      }
    },
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    sendMutation.mutateAsync()
  }

  if (!isOpen) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg mx-auto">
      <form onSubmit={handleSubmit}>
        <h2 className="text-lg font-medium mb-1 capitalize text-center">{`Send Message to ${targetUserType}`}</h2>
        {description && <p className="text-xs text-gray-600 mb-4 text-center">{description}</p>}
        <textarea
          className="px-3 py-2 w-full border border-secondary-600 rounded bg-secondary-50 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-secondary-600 focus:border-secondary-600 sm:text-sm"
          rows={4}
          placeholder="Type your message here..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />
        <div className="flex justify-end gap-3 mt-4">
          <button
            type="button"
            onClick={() => {
              setMessage('')
              onClose()
            }}
            className="px-4 py-2 flex-1 bg-neutral-200 rounded hover:bg-neutral-200"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 flex-1 bg-secondary-600 text-white  font-medium rounded-md shadow-md disabled:opacity-60"
            disabled={sendMutation.isLoading}
          >
            {sendMutation.isLoading ? 'Sending...' : 'Send'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
